import { render, staticRenderFns } from "./GreetingPage.vue?vue&type=template&id=0daf859f&scoped=true"
import script from "./GreetingPage.vue?vue&type=script&lang=js"
export * from "./GreetingPage.vue?vue&type=script&lang=js"
import style0 from "./GreetingPage.vue?vue&type=style&index=0&id=0daf859f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daf859f",
  null
  
)

export default component.exports